import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './About.css';

function About() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = 'About Us | Sapium Beauty - Professional Aesthetic & Laser Studio London';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Learn about Sapium Beauty - a professional aesthetic and laser studio in London. Expert treatments with advanced technology and personalized care. Meet our certified therapist.');
    }
  }, []);

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1>{t('about.hero.title')}</h1>
          <h2>{t('about.hero.subtitle')}</h2>
          <p>{t('about.hero.description')}</p>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="story-section">
        <div className="container">
          <div className="story-content">
            <h2>{t('about.story.title')}</h2>
            <p>{t('about.story.description')}</p>
            <div className="mission-statement">
              <h3>{t('about.story.missionTitle')}</h3>
              <p>{t('about.story.mission')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Meet Iryna Section */}
      <section className="specialist-section">
        <div className="container">
          <div className="specialist-content">
            <div className="specialist-info">
              <h2>{t('about.specialist.title')}</h2>
              <h3>{t('about.specialist.subtitle')}</h3>
              <p>{t('about.specialist.description')}</p>
              
              <div className="expertise">
                <h4>{t('about.specialist.expertiseTitle')}</h4>
                <ul>
                  {t('about.specialist.expertise', { returnObjects: true }).map((expertise, index) => (
                    <li key={index}>{expertise}</li>
                  ))}
                </ul>
              </div>
              
              <p className="approach">{t('about.specialist.approach')}</p>
            </div>
            <div className="specialist-image">
              <img src="/image/Iryna.jpg" alt={t('about.specialist.title')} />
            </div>
          </div>
        </div>
      </section>

      {/* Our Clinic Section */}
      <section className="clinic-section">
        <div className="container">
          <h2>{t('about.clinic.title')}</h2>
          <p>{t('about.clinic.description')}</p>
          
          <div className="clinic-features">
            <h3>{t('about.clinic.featuresTitle')}</h3>
            <ul>
              {t('about.clinic.features', { returnObjects: true }).map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Treatment Philosophy Section */}
      <section className="treatments-section">
        <div className="container">
          <h2>{t('about.treatments.title')}</h2>
          <p>{t('about.treatments.description')}</p>
        </div>
      </section>

      {/* Our Values Section */}
      <section className="values-section">
        <div className="container">
          <h2>{t('about.values.title')}</h2>
          <div className="values-grid">
            {t('about.values.items', { returnObjects: true }).map((value, index) => (
              <div key={index} className="value-card">
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="about-cta">
        <div className="container">
          <h2>{t('about.cta.title')}</h2>
          <p>{t('about.cta.description')}</p>
          <a href="https://widget.treatwell.co.uk/place/beauty-lounge-green-canning-town/" target="_blank" rel="noopener noreferrer" className="cta-button">{t('about.cta.button')}</a>
        </div>
      </section>
    </div>
  );
}

export default About; 